module.exports = __webpack_public_path__ + "img/kid2.cf624cca.png";